export default "__VITE_ASSET__Cww2DC27__"